export const FOLLOW_BASE_PATH = '/follow';
